// @flow
import type {Node} from 'react'
import React from 'react'

import type {PickAlert, UpdateCallback} from 'components/proposals/types'
import ValueInput from 'components/proposals/Part/ui/ValueInput'
import type {Circle, Organization} from 'components/proposals/Part/ui/ValueInput'
import Value from 'components/proposals/Part/ui/Value'
import FrogTipBox, {MarkdownTip} from 'components/ui/FrogTipBox'
import {useProposalContext} from 'contexts/ProposalContext'

type Props = {
  circle: ?Circle,
  disabled: boolean,
  id: string,
  label: string,
  onChange: UpdateCallback,
  organization: Organization,
  pickAlert: PickAlert,
  purpose: Value,
  strikethrough: boolean,
}

const markdownTip = () => (
  <MarkdownTip
    text={I18n.t('org_nav.tabs.overview_tab.purpose.markdown_tip')}
    bottomLink={I18n.t('org_nav.tabs.overview_tab.purpose.learn_more_link')}
  />
)

function RolePurpose(props: Props): Node {
  const proposalContext = useProposalContext()

  return (
    <ValueInput
      alert={props.pickAlert('purpose')}
      autofocus={false}
      circle={props.circle}
      className="test-edit-role-purpose"
      disabled={props.disabled}
      id={props.id}
      label={(
        <FrogTipBox
          hideDivider
          withBottomSpacing
          tip={markdownTip}
          target={props.label}
          helpFor={props.label}
        />
      )}
      aiSuggestProps={props.circle && proposalContext ? {
        context: {type: 'proposal', id: proposalContext?.databaseId},
        promptKey: 'suggest_proposal_purpose',
        data: {
          tensionBody: proposalContext?.tension?.body || '',
          circle: {ref_type: 'Circle', ref_id: props.circle.databaseId},
          // proposal: {ref_type: 'Proposal', ref_id: proposalContext?.proposal?.databaseId},
        },
      } : undefined}
      onChange={props.onChange}
      organization={props.organization}
      path={['purpose']}
      strikethrough={props.strikethrough}
      value={props.purpose}
      textarea
      placeholder={I18n.t('role.placeholders.purpose')}
    />
  )
}

RolePurpose.defaultProps = {
  circle: null,
  strikethrough: false,
}

export default RolePurpose
